<template>
  <div id="app">
    <transition :name="transitionName">
      <keep-alive :include="cachedViews">
        <router-view />
      </keep-alive>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      cachedViews: ['SuperLog', 'SuperLog2026', 'SuperInvoice', 'SuperJournal', 'SuperSignIn'],
      transitionName: ''
    }
  },
  watch: {
    $route(to, from) {
      if (!from.name) {
        this.transitionName = '';
        return;
      }
      if (to.meta.index > from.meta.index) {
        this.transitionName = 'slide-left';
      } else {
        this.transitionName = 'slide-right';
      }
    }
  }
};
</script>

<style>
.slide-left-enter { transform: translateX(100%); }
.slide-left-enter-active { transition: transform 300ms ease-in-out; }
.slide-left-enter-to { transform: translateX(0); }

.slide-left-leave { transform: translateX(0); }
.slide-left-leave-active { transition: transform 300ms ease-in-out; }
.slide-left-leave-to { transform: translateX(-100%); }

.slide-right-enter { transform: translateX(-100%); }
.slide-right-enter-active { transition: transform 300ms ease-in-out; }
.slide-right-enter-to { transform: translateX(0); }

.slide-right-leave { transform: translateX(0); }
.slide-right-leave-active { transition: transform 300ms ease-in-out; }
.slide-right-leave-to { transform: translateX(100%); }
</style>
